import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { SessionState } from '../../../../reducers/auth/session';
import { useHistory } from 'react-router-dom'
import { fetchNotifications } from '../../../../actions/notification/notificationList'
import Notifications from '../../Notifications'
import { AppState } from '../../../../reducers'
import { NotificationListState } from '../../../../reducers/notification/notificationList'

interface Props {
  fullInfo?: boolean
  notificationList: NotificationListState
  session?: SessionState
}

const NotificationList: React.FC<Props> = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    dispatch(fetchNotifications(history.location.search))
  }, [dispatch, history.location.search])
 

  return (
    <div>
      <Notifications
        rows={(props.notificationList.notifications || []).map(s => ({ data: s }))}
        loading={props.notificationList.isFetching}
        pagination={props.notificationList.pagination || undefined}
        session={props.session || undefined}
        fullInfo={props.fullInfo === undefined ? true : props.fullInfo}
      />
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  session: state.session,
  notificationList: state.notificationList,
})

export default connect(mapStateToProps, null)(NotificationList)